if (!customElements.get("product-tabs")) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute("id");
      this.scrollAnimId = null;

      if (Shopify.designMode) {
        window.addEventListener(
          "shopify:section:load",
          this.init.bind(this)
        );
        document.addEventListener("shopify:block:select", (evt) => {
          const blockId = evt.detail?.blockId;
          if (blockId) {
            const targetTrigger = this.querySelector(`[data-block-id="${blockId}"]`) || this.querySelector(`[data-tab*="${blockId}"]`);
            if (targetTrigger) {
              targetTrigger.click();
            }
          }
        });
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.querySelectorAll(".product__tab--trigger").forEach(
        tabTrigger => {
          tabTrigger.addEventListener("click", evt => {
            evt.preventDefault();
            this.openTab(
              evt,
              tabTrigger.dataset.tab,
              true
            );
            if (typeof tabTrigger.blur === "function") {
              tabTrigger.blur();
            }
          });
        }
      );

      this.openDefaultTab();
    }

    openDefaultTab() {
      const defaultTab = this.querySelector(".product__tab[data-default-open]") || this.querySelector(".product__tab--trigger");
      if (defaultTab && defaultTab.dataset.tab) {
        this.openTab(null, defaultTab.dataset.tab, false);
      }
    }

    openTab(evt, tabName, shouldScroll = true) {
      const tabcontents = this.querySelectorAll(
        ".product__tab-content"
      );
      tabcontents.forEach(content => {
        content.style.display = "none";
      });

      const tablinks = this.querySelectorAll(".product__tab");
      tablinks.forEach(link => {
        link.classList.remove("active");
      });

      const currentTabContent = this.querySelector(`#${tabName}`);

      if (currentTabContent) {
        currentTabContent.style.display = "block";
        const trigger = (evt && evt.currentTarget) || this.querySelector(`.product__tab[data-tab="${tabName}"]`);
        if (trigger) {
          trigger.classList.add("active");
          if (shouldScroll) {
            this.scrollTabIntoView(trigger);
          }
        }
      }
    }

    scrollTabIntoView(trigger) {
      const tabsContainer = this.querySelector(".product__tabs");
      if (!tabsContainer || !trigger) return;

      const containerRect = tabsContainer.getBoundingClientRect();
      const triggerRect = trigger.getBoundingClientRect();
      let scrollOffset = 0;

      if (triggerRect.right > containerRect.right) {
        scrollOffset = triggerRect.right - containerRect.right + 20;
      } else if (triggerRect.left < containerRect.left) {
        scrollOffset = triggerRect.left - containerRect.left - 20;
      }

      if (scrollOffset === 0) return;

      if (this.scrollAnimId) {
        cancelAnimationFrame(this.scrollAnimId);
        this.scrollAnimId = null;
      }

      // Check for reduced motion preference
      const prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (prefersReducedMotion) {
        tabsContainer.scrollLeft += scrollOffset;
        return;
      }

      // Smoothly animate only the tabsContainer's horizontal scrollLeft via requestAnimationFrame
      // Avoids native scrollBy({ behavior: "smooth" }) which triggers iOS Safari/WebKit window viewport jumps
      const startLeft = tabsContainer.scrollLeft;
      const targetLeft = startLeft + scrollOffset;
      const duration = 200;
      const startTime = performance.now();

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        // easeOutQuad
        const ease = 1 - (1 - progress) * (1 - progress);
        tabsContainer.scrollLeft = startLeft + (targetLeft - startLeft) * ease;

        if (progress < 1) {
          this.scrollAnimId = requestAnimationFrame(animate);
        } else {
          this.scrollAnimId = null;
        }
      };

      this.scrollAnimId = requestAnimationFrame(animate);
    }
  }
  customElements.define("product-tabs", ProductTabs);
}
